import axios from 'axios'

export const getAllDistrict = (params) => {
  return axios.get('districts', {params: params})
}

export const getDistrict = (id, params) => {
  return axios.get('districts/' + id, {params: params})
}

export const getDistrictKind = (params) => {
  return axios.get('helpers/districts', {params: params})
}

export const addDistrict = (data) => {
  return axios.post('districts', data)
}

export const editDistrict = (id, data) => {
  return axios.put('districts/' + id, data)
}

export const deleteDistrict = (id) => {
  return axios.delete('districts/' + id)
}

export const restoreDistrict = (id) => {
  return axios.post('districts/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/district.js